import css from 'styled-jsx/css';

export default css.global`.footer-content {
  padding: 3rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.footer-content > div {
  margin-bottom: 1.5rem;
}

.footer-content-contact a {
  color: var(--brand-blue);
  font-weight: 700;
  margin-bottom: 0;
  font-size: 16px;
}

.footer-content-social {
  display: flex;
  align-items: start;
  font-size: 16px;
  gap: 1rem;
  color: var(--brand-red);
  font-weight: 700;
}

.footer-content-social span,
.footer-content-social a {
  margin-right: 1rem;
}

.footer-content-copy p {
  font-size: 16px;
}

@media (min-width: 1280px) {
  .footer-content {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .footer-content p {
    margin-bottom: 0;
  }

  .footer-content > div {
    margin-bottom: 0;
  }
}
`